import { MainLayoutOutletContext } from "./model";
import { useOutletContext } from "react-router-dom";

const useMainLayoutOutletContext = (): MainLayoutOutletContext => {
  return useOutletContext<MainLayoutOutletContext>();
};

export default useMainLayoutOutletContext;
